// components
import { useGetObjects } from '../../hooks/useGetObjects';
import { LoadingView } from '../../components';
import { GoogleMap } from '../../components/Map';
import { TMarker } from '../../components/Map/Map';
import { useEffect, useState } from 'react';

export function BuildingsMap() {
    const { objects, error, isLoading, isSuccess } = useGetObjects();
    const [markers, setMarkers] = useState<TMarker[]>([]);

    useEffect(() => {
        const markers = objects?.filter((i: any) => i.address !== undefined).map((item: any) => {
            return {
                latitude: item.address.latitude,
                longitude: item.address.longitude,
                title: item.description
            }
        });
        setMarkers(markers || []);
    }, [objects])

    return (
        <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
            <GoogleMap width='100%' height='80vh' markers={markers} initialZoom={5}   ></GoogleMap>
        </LoadingView>
    );
}

